(ns app.front.ui.call-to-action
  "Components for displaying calls to action."
  (:require [app.front.ui.panels :as panels]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.side-panel :as side-panel]
            [app.front.util :as futil]
            [app.front.view.landing-page-subs :as landing-page-subs]
            [app.i18n.model :as i18n-model]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::open-panel
  :<- [::panels/open-panel]
  (fn [open-panel _]
    (when-let [[panel-kind {:keys [index]}] open-panel]
      (when (= panel-kind :cta)
        index))))

(rf/reg-sub ::panel-open?
  :<- [::open-panel]
  :-> boolean)

(rf/reg-event-fx ::toggle-open
  (fn [_ [_ index]]
    {:dispatch [::panels/toggle [:cta {:index index}]]}))

(defn- first-meeting [call-to-action]
  (-> call-to-action :call-to-action/data :meetings first))

(defn call-to-action-title
  ([call-to-action lang]
   (call-to-action-title call-to-action lang false))
  ([call-to-action lang for-panel?]
   (if (or for-panel? (not= (:call-to-action/kind call-to-action) :dynamic-call-to-action.kind/committee-meetings))
     (i18n-model/get-text-from-entities-or-map (:call-to-action/title call-to-action) lang)
     (if-let [{:keys [committee]} (first-meeting call-to-action)]
       (i18n-model/get-text-from-entities-or-map committee lang)
       ((<sub [:tr]) [:group/branding-cta-no-upcoming-meetings])))))

(defn call-to-action-subtitle [call-to-action lang]
  (if (not= (:call-to-action/kind call-to-action) :dynamic-call-to-action.kind/committee-meetings)
    (i18n-model/get-text-from-entities-or-map (:call-to-action/subtitle call-to-action) lang)
    (if-let [{:keys [start]} (first-meeting call-to-action)]
      ((<sub [::date-util/date-time-fn]) start)
      "")))

(def dynamic-cta-content-views
  {:dynamic-call-to-action.kind/committee-meetings
   (fn [cta _open-panel lang]
     (let [tr          (<sub [:tr])
           format-date (<sub [::date-util/date-time-fn])
           meetings    (-> cta :call-to-action/data :meetings)]
       [:ul
        (if (empty? meetings)
          [:li.pb-4 (tr [:group/branding-cta-no-upcoming-meetings])]
          (futil/for-frag-indexed [[idx {:keys [committee start]}] meetings]
            ^{:key (str "cta-view-meeting-li-" idx)}
            [:li.pb-4
             [:h4 (i18n-model/get-text-from-entities-or-map committee lang)]
             [:div.mt-2 (format-date start)]]))]))})


(defn- static-cta-content [cta open-panel lang]
  (let [content (i18n-model/get-text-from-entities-or-map
                  (:call-to-action/content cta) lang)]
    [ui-rt/editor-legacy {:id                 (str "cta-content-" open-panel)
                          :initial-html-value content}]))

(defn call-to-action-panel []
  (let [open-panel      (<sub [::open-panel])
        panel-open?     (<sub [::panel-open?])
        lang            (<sub [:language])
        calls-to-action (<sub [::landing-page-subs/calls-to-action])
        call-to-action  (when panel-open?
                          (get calls-to-action open-panel))
        cta-kind        (:call-to-action/kind call-to-action)
        cta-view        (get dynamic-cta-content-views cta-kind static-cta-content)]
    [side-panel/side-panel
     {:panel-open? panel-open? :panel-id :call-to-action}
     (when call-to-action
       [:div {:key (str "cta-panel-" lang)}
        [side-panel/title (call-to-action-title call-to-action lang true)]
        [:div.flex.flex-col.gap-2.mt-5
         [cta-view call-to-action open-panel lang]]])]))
